/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_violin_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is a distribution plot that shows a smoothed density curve for each group, mirrored to form a violin shape. It combines the summary of a box plot with the full shape of the distribution.`)
};

const es_violin_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es un gráfico de distribución que muestra una curva de densidad suavizada para cada grupo, reflejada para formar una figura de violín. Combina el resumen de un diagrama de caja con la forma completa de la distribución.`)
};

const de_violin_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es ist ein Verteilungsdiagramm, das für jede Gruppe eine geglättete Dichtekurve zeigt, gespiegelt zu einer Violinenform. Es kombiniert die Zusammenfassung eines Boxplots mit der vollständigen Form der Verteilung.`)
};

const nl_violin_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het is een verdelingsplot die een gladde dichtheidscurve toont voor elke groep, gespiegeld tot een vioolvorm. Het combineert de samenvatting van een boxplot met de volledige vorm van de verdeling.`)
};

const fr_violin_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est un graphique de distribution qui montre une courbe de densité lissée pour chaque groupe, reflétée en miroir pour former une forme de violon. Il combine le résumé d'un box plot avec la forme complète de la distribution.`)
};

const it_violin_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È un grafico di distribuzione che mostra una curva di densità levigata per ciascun gruppo, speculare per formare una forma a violino. Combina il riepilogo di un box plot con la forma completa della distribuzione.`)
};

const pt_br2_violin_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É um gráfico de distribuição que mostra uma curva de densidade suavizada para cada grupo, espelhada para formar um formato de violino. Ele combina o resumo de um box plot com o formato completo da distribuição.`)
};

const pt_violin_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É um gráfico de distribuição que mostra uma curva de densidade suavizada para cada grupo, espelhada de forma a criar uma forma de violino. Combina o resumo de um box plot com a forma completa da distribuição.`)
};

const ja_violin_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`各グループについて滑らかな密度曲線を示し、それを鏡写しにしてバイオリンの形にした分布プロットです。箱ひげ図の要約と分布全体の形状を組み合わせたものです。`)
};

const zh_violin_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`小提琴图是一种分布图，为每组数据显示一条平滑的密度曲线，并镜像形成小提琴形状。它结合了箱形图的摘要信息与分布的完整形状。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const violin_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.violin_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("violin_faq_a1", locale)
	if (locale === "en") return en_violin_faq_a1(inputs)
	if (locale === "es") return es_violin_faq_a1(inputs)
	if (locale === "de") return de_violin_faq_a1(inputs)
	if (locale === "nl") return nl_violin_faq_a1(inputs)
	if (locale === "fr") return fr_violin_faq_a1(inputs)
	if (locale === "it") return it_violin_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_violin_faq_a1(inputs)
	if (locale === "pt") return pt_violin_faq_a1(inputs)
	if (locale === "ja") return ja_violin_faq_a1(inputs)
	return zh_violin_faq_a1(inputs)
};